import React from "react";
import './index.css'
import { secureUrl } from "../../../../utils/sortArray/secureUrl";

const HeaderPlantila = ({team})=>{
    const buildImgText = (img, name)=>(
            <div className="img-text-header" >
                    <img src={secureUrl(img)} />
                    <p >{name}</p>
                </div>
    )
    return(
        <div>
            <div className="container-header-plantilla" >
                <p className="container-title-plantilla" >Plantilla</p>
                <div className="container-title-name-cup">
                {buildImgText(team?.pictureTeam,team?.name)}
                {buildImgText(team?.torneo?.imgPicture, team?.torneo?.name)}
                </div>

            </div>
        </div>
    )
}

export default HeaderPlantila